import { render, staticRenderFns } from "./confirmDeduction.vue?vue&type=template&id=6db983e8&scoped=true"
import script from "./confirmDeduction.vue?vue&type=script&lang=js"
export * from "./confirmDeduction.vue?vue&type=script&lang=js"
import style0 from "./confirmDeduction.vue?vue&type=style&index=0&id=6db983e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db983e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db983e8')) {
      api.createRecord('6db983e8', component.options)
    } else {
      api.reload('6db983e8', component.options)
    }
    module.hot.accept("./confirmDeduction.vue?vue&type=template&id=6db983e8&scoped=true", function () {
      api.rerender('6db983e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/DeductionConfirmationForm/component/confirmDeduction.vue"
export default component.exports